/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Artifactpackfinalisefact3Inputs */

const en_artifactpackfinalisefact3 = /** @type {(inputs: Artifactpackfinalisefact3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add ${i?.label} →`)
};

const pt_artifactpackfinalisefact3 = /** @type {(inputs: Artifactpackfinalisefact3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Adicionar ${i?.label} →`)
};

/**
* | output |
* | --- |
* | "Add {label} →" |
*
* @param {Artifactpackfinalisefact3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const artifactpackfinalisefact3 = /** @type {((inputs: Artifactpackfinalisefact3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifactpackfinalisefact3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_artifactpackfinalisefact3(inputs)
	return pt_artifactpackfinalisefact3(inputs)
});
export { artifactpackfinalisefact3 as "artifactPackFinaliseFact" }